export const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'moves', label: 'Needs work' },
  { key: 'ontarget', label: 'On target' },
  { key: 'skin', label: 'Skin' },
  { key: 'mono', label: 'B&W' },
  { key: 'undecided', label: 'Undecided' },
  { key: 'decided', label: 'Decided' },
];

export const SCENE_KEYS = ['golden_hour', 'daylight', 'shade', 'tungsten', 'fluorescent', 'flash', 'night', 'mixed'];

export const thumbUrl = (img) => img.variants?.social || img.variants?.web || img.image_url;
export const fullUrl = (img) => img.variants?.web || img.image_url;
export const displayName = (img, i) => img.original_filename || img.caption || `Photo ${i + 1}`;

export const movesOf = (img) => (img.color?.recommendations?.items || []).filter((it) => it.strength !== 'none');

export const matchesFilter = (img, filter) => {
  const a = img.color?.analysis;
  const d = img.color?.decisions || {};
  switch (filter) {
    case 'moves': return movesOf(img).length > 0;
    case 'ontarget': return Boolean(a) && movesOf(img).length === 0;
    case 'skin': return Boolean(a?.skin?.detected);
    case 'mono': return Boolean(a?.monochrome);
    case 'undecided': return Boolean(a) && movesOf(img).length > 0 && Object.keys(d).length === 0;
    case 'decided': return Object.keys(d).length > 0;
    default: return true;
  }
};

export const scoreTone = (s) => (s == null ? 'text-[hsl(var(--lxra-muted))]' : s >= 90 ? 'text-emerald-300' : s >= 75 ? 'text-[hsl(var(--lxra-gold))]' : s >= 55 ? 'text-amber-300' : 'text-red-300');

export const fmtK = (k) => (k ? `${k.toLocaleString()} K` : '—');
export const fmtEV = (ev) => (ev == null ? '—' : `${ev > 0 ? '+' : ''}${ev.toFixed(1)} EV`);

export const decisionCounts = (img) => {
  const d = img.color?.decisions || {};
  const moves = movesOf(img).map((m) => m.param);
  const decided = moves.filter((p) => d[p]);
  return { moves: moves.length, decided: decided.length, accepted: decided.filter((p) => d[p].state === 'accepted').length, modified: decided.filter((p) => d[p].state === 'modified').length, rejected: decided.filter((p) => d[p].state === 'rejected').length };
};
